export const educations = [
  {
    name: "Bachelor of Computer Science & Engineering",
    from: "Lovely Professional University",
    location: "Jalandhar, Punjab, India - 144411",
    year: "2017",
    grade: "8.45 CGPA"
  },
  {
    name: "Higher Secondary Education",
    from: "Jawahar Navodaya Vidyalaya",
    location: "Pfukhro, Mao Gate, Senapati, Manipur, India - 795150",
    year: "2013",
    grade: "87.5%"
  }
]